class ProductPopup extends HTMLElement {
  constructor() {
    super();

    // Show popup when add to cart button is not showing
    this.updateProductPopup = this.updateProductPopup.bind(this);

    window.addEventListener("scroll", this.updateProductPopup);
    window.addEventListener("load", this.updateProductPopup);

    const popupContainer = document.getElementById("product-popup");

    if (popupContainer) {
      popupContainer.style.display = "flex";
    }

    // Scroll to product when popup buy button is pressed (1 > variants)
    const popupBuyBtn = document.getElementById(
      "ProductPopup--VariantsSubmitButton"
    );

    if (popupBuyBtn) {
      popupBuyBtn.addEventListener("click", this.scrollToBuyButton);
    }

    // Add to cart when popup buy button is pressed (1 == variants)
    const addToCartBtn = document.getElementById(
      "ProductPopup--AddToCartButton"
    );

    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", this.addToCart);
    }
  }

  addToCart() {
    const productForm = document.querySelector(
      '[data-type="add-to-cart-form"]'
    );

    if (!productForm) return;

    const productSubmitButton = productForm.querySelector(
      "button.add-to-cart:not([disabled])"
    );

    if (!productSubmitButton) return;

    productSubmitButton.click();
  }

  scrollToTitle() {
    const productContainer = document.querySelector("product-info");

    if (!productContainer) return;

    const productContainerPos = productContainer.getBoundingClientRect().top;
    const offsetPosition = productContainerPos + window.pageYOffset - 200;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  scrollToBuyButton() {
    const buyBtn = document.querySelector('button.product-popup-scroll-btn');

    if (!buyBtn) return;

    buyBtn.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  }

  getContainerHeight() {
    return getComputedStyle(document.documentElement).getPropertyValue(
      "--product-popup-container-height"
    );
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 100 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  updateProductPopup() {
    const negishot = document.querySelector('.smart-accessibility-widget .sa-widget__cta.icon-small')
    const mainProductBuyBtn = document.getElementById("main-product-buy-btn");
    const popupContainer = document.getElementById("product-popup");

    if (mainProductBuyBtn && popupContainer) {
      if (!this.isInViewport(mainProductBuyBtn)) {
        negishot.style.setProperty('bottom', '90px', 'important');
      } else {
        negishot.style.setProperty('bottom', '32px', 'important');
      }
      popupContainer.style.bottom = !this.isInViewport(mainProductBuyBtn)
        ? "0px"
        : `-${this.getContainerHeight()}`;
    }
  }
}

customElements.define("product-popup", ProductPopup);
